
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/change-password",
      function () {
        return require("private-next-pages/auth/change-password.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/change-password"])
      });
    }
  